import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import ThanksVIP from './ThanksVIP';
import LegalPages from './LegalPages';

function Home() {
    useEffect(() => {
        document.title = "上岸消考 - 中级考试一站式神器";
    }, []);

    // ========== 手机端导航菜单展开/收起 ==========
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);

    const carouselImages = [
        { src: "/images/home.png", alt: "上岸消考-软件实际界面" },
        { src: "/images/home-vip.png", alt: "上岸消考-vip软件实际界面" },
        { src: "/images/practice.png", alt: "上岸消考-练习界面" },
        { src: "/images/exam.png", alt: "上岸消考-考试界面" },
    ];
    const [currentImgIndex, setCurrentImgIndex] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImgIndex(prev => (prev + 1) % carouselImages.length);
        }, 3000); 
        return () => clearInterval(timer);
    }, [carouselImages.length]);
    // ========== 轮播配置结束 ==========

    // ========== 安装教程视频弹窗 ==========
    const [videoModal, setVideoModal] = useState({ open: false, src: '', title: '' });

    const openVideoModal = (src, title) => {
        setVideoModal({ open: true, src, title });
    };
    const closeVideoModal = () => {
        setVideoModal({ open: false, src: '', title: '' });
    };
    // ESC 键关闭弹窗
    useEffect(() => {
        if (!videoModal.open) return;
        const handleEsc = (e) => {
            if (e.key === 'Escape') closeVideoModal();
        };
        document.addEventListener('keydown', handleEsc);
        // 弹窗打开时禁止背景滚动
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [videoModal.open]);
    // ========== 视频弹窗配置结束 ==========

    // 配置下载链接：保持不变
    const downloadUrls = {
        windows: "https://shanganxiaokao.com/上岸消考安装包.exe",
        windowsPortable: "https://shanganxiaokao.com/上岸消考免安装版.zip",
        mac: "#",
        android: "https://shanganxiaokao.com/shanganxiaokao.apk",
        ios: "#"
    };

    return (
        <div className="app-container">
            {/* 导航栏：保持不变 */}
            <nav className="navbar">
                <div className="navbar-logo">
                    <h2>上岸消考</h2>
                </div>
                <button
                    className={`navbar-toggle ${menuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label="菜单"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
                    <a href="#home" onClick={closeMenu}>首页</a>
                    <a href="#features" onClick={closeMenu}>软件特色</a>
                    <a href="#download" onClick={closeMenu}>立即下载</a>
                </div>
            </nav>

            {/* 英雄横幅：仅修改mock-screen内部，新增轮播 */}
            <section id="home" className="hero-section">
                <div className="hero-content">
                    <h1>中级消防设施操作员<br/>一站式备考神器</h1>
                    <p>海量真题 | 考点精讲 | 模拟考试 | 错题归集</p>
                    <a href="#download" className="hero-download-btn">立即下载</a>
                </div>
                <div className="hero-img">
                  <div className="mock-screen">
                    {/* ========== 新增：轮播容器 ========== */}
                    <div className="carousel-container">
                        {/* 显示当前轮播图片 */}
                        <img 
                          src={carouselImages[currentImgIndex].src}  
                          alt={carouselImages[currentImgIndex].alt} 
                          className="carousel-img"
                        />
                        {/* 轮播指示器（小点，可选） */}
                        <div className="carousel-indicators">
                            {carouselImages.map((_, idx) => (
                                <span 
                                    key={idx}
                                    className={`indicator-dot ${idx === currentImgIndex ? 'active' : ''}`}
                                    onClick={() => setCurrentImgIndex(idx)} // 点击小点手动切换
                                ></span>
                            ))}
                        </div>
                    </div>
                    {/* ========== 轮播容器结束 ========== */}
                  </div>
                </div>
            </section>

            {/* 软件特色：保持不变 */}
            <section id="features" className="features-section">
                <h2 className="section-title">软件核心特色</h2>
                <div className="features-list">
                    <div className="feature-card">
                        <h3>真题全覆盖</h3>
                        <p>收录中级消防设施操作员考试真题，附带详细解析，吃透考点精髓</p>
                    </div>
                    <div className="feature-card">
                        <h3>AI智能答疑</h3>
                        <p>RAG+AI智能答疑系统，精准解答疑惑，提升学习效率</p>
                    </div>
                    <div className="feature-card">
                        <h3>全真模拟考场</h3>
                        <p>还原真实考试场景、计时规则，提前适应考试节奏，避免临场紧张</p>
                    </div>
                    <div className="feature-card">
                        <h3>错题自动归集</h3>
                        <p>自动记录错题，生成专属错题本，针对性强化训练，快速查漏补缺</p>
                    </div>
                </div>
            </section>

            {/* 下载区域：保持不变 */}
           <section id="download" className="download-section">
                <h2 className="section-title">立即下载备考软件</h2>
                <p className="download-desc">支持电脑端/手机端多平台，安全无毒，免费更新</p>

                {/* ====== 电脑端 ====== */}
                <div className="download-group">
                    <div className="group-title-row">
                        <h3 className="group-title">💻 电脑端</h3>
                        <button
                            className="tutorial-btn"
                            onClick={() => openVideoModal('/videos/windows-install-tutorial.mp4', 'PC安装教学')}
                        >
                            📺 安装教程
                        </button>
                    </div>
                    <div className="download-list">
                        <div className="download-card">
                            <h3>Windows 版本(内测中)</h3>
                            <p>✅ 支持Win7/Win10/Win11<br/>✅ 自动保留用户数据（错题本、练习记录）</p>
                            <div className="download-card-actions">
                                <button
                                    className="download-btn"
                                    onClick={() => {
                                        const testCode = prompt("请输入内测码：");
                                        if (testCode === "123") {
                                            // 记录下载统计信息
                                            fetch('https://api.shanganxiaokao.com/stats/download', {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify({
                                                    download_type: 'windows',
                                                    source: 'website_home'
                                                })
                                            }).catch(error => {
                                                console.log('下载统计记录失败:', error);
                                            });

                                            window.open(downloadUrls.windows, "_blank");
                                        } else {
                                            alert("内测码错误，请确认后重试");
                                        }
                                    }}
                                >
                                    下载安装包（约90MB）
                                </button>
                            </div>
                        </div>
                        <div className="download-card">
                            <h3>Windows 免安装版</h3>
                            <p>✅ 支持Win7/Win10/Win11<br/>✅ 免安装，下载解压即可运行</p>
                            <button
                                className="download-btn"
                                onClick={() => {
                                    const testCode = prompt("请输入内测码：");
                                    if (testCode === "123") {
                                        fetch('https://api.shanganxiaokao.com/stats/download', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify({
                                                download_type: 'windows_portable',
                                                source: 'website_home'
                                            })
                                        }).catch(error => {
                                            console.log('下载统计记录失败:', error);
                                        });

                                        window.open(downloadUrls.windowsPortable, "_blank");
                                    } else {
                                        alert("内测码错误，请确认后重试");
                                    }
                                }}
                            >
                                下载免安装版（ZIP压缩包）
                            </button>
                        </div>
                        <div className="download-card">
                            <h3>Mac 版本</h3>
                            <p>🔜 即将上线，敬请期待！<br/>支持macOS 10.15及以上系统</p>
                            <a
                                href={downloadUrls.mac}
                                className="download-btn"
                                download="上岸消考-中级消防考试软件-Mac.dmg"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    alert("Mac版本暂未上线，建议先下载Windows版本使用～");
                                }}
                            >
                                下载安装包（敬请期待）
                            </a>
                        </div>
                    </div>
                </div>

                {/* ====== 手机端 ====== */}
                <div className="download-group">
                    <div className="group-title-row">
                        <h3 className="group-title">📱 手机端</h3>
                        <button
                            className="tutorial-btn"
                            onClick={() => openVideoModal('/videos/android-install-tutorial.mp4', 'Android 安装教学')}
                        >
                            📺 安装教程
                        </button>
                    </div>
                    <div className="download-list">
                        <div className="download-card">
                            <h3>Android 安卓版(内测中)</h3>
                            <p>✅ 支持Android 8.0及以上系统<br/>✅ 自动保留用户数据（错题本、练习记录）</p>
                            <div className="download-card-actions">
                                <button
                                    className="download-btn"
                                    onClick={() => {
                                        const testCode = prompt("请输入内测码：");
                                        if (testCode === "123") {
                                            fetch('https://api.shanganxiaokao.com/stats/download', {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify({
                                                    download_type: 'android',
                                                    source: 'website_home'
                                                })
                                            }).catch(error => {
                                                console.log('下载统计记录失败:', error);
                                            });

                                            window.open(downloadUrls.android, "_blank");
                                        } else {
                                            alert("内测码错误，请确认后重试");
                                        }
                                    }}
                                >
                                    下载APK安装包
                                </button>
                            </div>
                        </div>
                        <div className="download-card">
                            <h3>iOS 苹果版</h3>
                            <p>🔜 即将上线，敬请期待！<br/>支持iOS 14.0及以上系统</p>
                            <a
                                href={downloadUrls.ios}
                                className="download-btn"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    alert("iOS苹果版本暂未上线，敬请期待！建议先下载安卓版本使用～");
                                }}
                            >
                                下载安装包（敬请期待）
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* 底部信息 */}
            {/* 安装教程视频弹窗 */}
            {videoModal.open && (
                <div className="video-modal-overlay" onClick={closeVideoModal}>
                    <div className="video-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="video-modal-header">
                            <h3>{videoModal.title}</h3>
                            <button className="video-modal-close" onClick={closeVideoModal} aria-label="关闭">
                                ✕
                            </button>
                        </div>
                        <div className="video-modal-body">
                            <video
                                src={videoModal.src}
                                controls
                                autoPlay
                                preload="metadata"
                                playsInline
                            >
                                您的浏览器不支持视频播放，请升级浏览器或下载视频观看。
                            </video>
                        </div>
                    </div>
                </div>
            )}

            <footer className="footer">
                <p>© 2026 上岸消考 版权所有 | 专注中级消防设施操作员考试上岸</p>
                <div style={{ marginTop: '10px' }}>
                    <Link
                        to="/privacy-policy"
                        style={{ color: '#edf2f7', marginRight: '20px', textDecoration: 'underline', display: 'inline-block', padding: '5px 10px' }}
                    >
                        隐私政策及用户协议
                    </Link>
                </div>
                <p className="footer-icp">备案号：京ICP备2025152775号-1</p>
            </footer>
        </div>
    );
}

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/thanks-vip" element={<ThanksVIP />} />
                <Route path="*" element={<LegalPages />} />
            </Routes>
        </Router>
    );
}

export default App;